import React from 'react';
import { Link } from 'react-router-dom';
import './light.css';
import { Container, Message } from 'semantic-ui-react';

export function PleaseLogin() {
	const next = encodeURIComponent(window.location.pathname + window.location.search);

	return (
		<Container text>
			<Message warning>
				<Message.Header>You must login before you can do that!</Message.Header>
				<p>Visit our <Link to={'/?next=' + next}>login page</Link>, then try again.</p>
			</Message>

			<div className="photo-404-container"><img className='photo-404' src='/404.jpg' /></div>
			<p style={{ textAlign: 'right' }}>
				<i>Test Rocket Launch, Matthew Patrick &amp; Protospace (2026)</i>
				<br/><i>Image Credit: Jordan Loehr</i>
			</p>
		</Container>
	);
};

export function NotFound() {
	return (
		<Container text>
			<Message warning>
				<Message.Header>The page you requested can't be found!</Message.Header>
				<p>Visit our <Link to='/'>home page</Link> if you are lost.</p>
			</Message>

			<div className="photo-404-container"><img className='photo-404' src='/404.jpg' /></div>
			<p style={{ textAlign: 'right' }}>
				<i>Test Rocket Launch, Matthew Patrick &amp; Protospace (2026)</i>
				<br/><i>Image Credit: Jordan Loehr</i>
			</p>
		</Container>
	);
};

